import { render, staticRenderFns } from "./PricingTierList.vue?vue&type=template&id=b0066f3c&scoped=true"
import script from "./PricingTierList.vue?vue&type=script&lang=js"
export * from "./PricingTierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0066f3c",
  null
  
)

export default component.exports